<template>
  <PrintPageLandscape
    :page-number="pageNumber"
    :page-count="pageCount"
    :background-image-url="'/img/short_teaser/short_teaser_bg.png'"
  >
    <div class="short-teaser-inner-page" :data-project-number="project ? project.number : null">
      <h2 class="short-teaser-inner-page__heading">{{ $t('technicalData') }}</h2>
      <div class="short-teaser-inner-page__main">
        <table class="short-teaser-technical-table">
          <thead>
            <tr>
              <th
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--headInformation"
                scope="col"
              >
                {{ $t('shortTeaserPrintPage4_tableInformationColumn') }}
              </th>
              <th
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--headData"
                scope="col"
              >
                {{ $t('data') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--informationColumn"
              >
                {{ $t('shortTeaserPrintPage4_technical_rowAreaInformation') }}
              </td>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--dataColumn"
              >
                {{ technicalTableAreaSquareMetersFormattedOrDash }}
                {{ ' ' + $t('shortTeaserPrintPage4_technical_value_squareMeterUnit') }}
              </td>
            </tr>
            <tr>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--informationColumn"
              >
                {{ $t('shortTeaserPrintPage4_technical_rowPlantTypeInformation') }}
              </td>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--dataColumn"
              >
                {{ $t('shortTeaserPrintPage4_technical_value_roofPlantType') }}
              </td>
            </tr>
            <tr>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--informationColumn"
              >
                {{ $t('shortTeaserPrintPage4_technical_rowInstalledPowerLabel') }}
              </td>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--dataColumn"
              >
                {{ powerKwpFormatted }}
              </td>
            </tr>
            <tr>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--informationColumn"
              >
                {{ $t('shortTeaserPrintPage4_technical_rowYieldLabel') }}
              </td>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--dataColumn"
              >
                {{ specificAnnualYieldKwhPerKwpFormatted }}
              </td>
            </tr>
            <tr>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--informationColumn"
              >
                {{ $t('shortTeaserPrintPage4_technical_rowFeedInLabel') }}
              </td>
              <td
                class="short-teaser-technical-table__cell short-teaser-technical-table__cell--dataColumn"
              >
                {{ technicalTableFeedInGuaranteeCtPerKwhFormattedOrDash }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import { formatNumber, NUMBER_FORMAT, parseFiniteNumber } from '@/helpers/numberFormat';

export default {
  name: 'ShortTeaserPrintPage4',

  components: {
    PrintPageLandscape,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    technicalTableAreaSquareMetersFormattedOrDash() {
      return formatNumber(
        this.project?.investmentDeductionAllowance?.areaInSquareMeters,
        NUMBER_FORMAT.DECIMAL
      );
    },

    powerKwpFormatted() {
      return formatNumber(
        this.project?.solarPlant?.solarPlantOverallPower,
        NUMBER_FORMAT.DECIMAL_TRIPLE
      );
    },

    technicalTableFeedInGuaranteeCtPerKwhFormattedOrDash() {
      const eurosPerKilowattHour = parseFiniteNumber(
        this.project?.investmentDeductionAllowance?.calculatedEEGfeedInTariffEurPerKwh
      );
      const centsPerKilowattHour =
        eurosPerKilowattHour === null ? null : eurosPerKilowattHour * 100;
      return formatNumber(centsPerKilowattHour, NUMBER_FORMAT.DECIMAL_TRIPLE);
    },

    specificAnnualYieldKwhPerKwpFormatted() {
      return formatNumber(
        this.project?.investmentDeductionAllowance?.specificAnnualYieldKwhPerKwp,
        NUMBER_FORMAT.DECIMAL
      );
    },
  },
};
</script>
